import React from 'react';
import ReactDOM from 'react-dom/client';
// import './styles/global.css';
import './styles/main.css';
import App from './App';
import './styles/sol-holdings.css';
import './styles/swipper-bundle.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);